import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { userActions } from './user-slice';

const AuthContext = React.createContext({
  login: (_accessToken: string) => {
    // initial login method
  },
  logout: () => {
    // initial logout method
  },
});

const retrieveStoredLoggedUser = (dispatch: any) => {
  const storedAccessToken = localStorage.getItem('access_token');

  storedAccessToken &&
    dispatch(
      userActions.setLoggedUser({
        accessToken: storedAccessToken,
      })
    );
};

export const AuthContextProvider = (props: any) => {
  const history = useHistory();
  const dispatch = useDispatch();
  retrieveStoredLoggedUser(dispatch);

  const logoutHandler = useCallback(() => {
    dispatch(userActions.setLoggedUser(null));

    localStorage.removeItem('access_token');

    history.push('/login');
  }, [dispatch, history]);

  const loginHandler = (accessToken: string) => {
    dispatch(
      userActions.setLoggedUser({
        accessToken: accessToken,
      })
    );
    localStorage.setItem('access_token', accessToken);
    history.push('/');
  };

  const contextValue = {
    login: loginHandler,
    logout: logoutHandler,
  };

  return <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>;
};

export default AuthContext;
